import { OperationsPrincipals } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const MyFeedbackPage = lazyPage(() => import("../pilot/MyFeedbackPage"), "MyFeedbackPage");
const PilotGuidePage = lazyPage(() => import("../pilot/PilotGuidePage"), "PilotGuidePage");
const PilotHubPage = lazyPage(() => import("../pilot/PilotHubPage"), "PilotHubPage");

// Pilot feedback area (release 1.2.0, O-R34): My feedback (My work), the Pilot hub (Admin) and the Pilot guide (About,
// also routed at /pilot/guide). The floating "Pilot feedback" button itself is mounted by the app shell.
export { MyFeedbackPage, PilotGuidePage, PilotHubPage };

export const pilotRoutes: AreaRoute[] = [
  { path: "/pilot/guide", allow: OperationsPrincipals, element: <PilotGuidePage /> }
];
